﻿export default class DropDownTreeControl {

    constructor(ctrlSelector, dataURL, filter, defaultValue, enabled, onlyLeafSelection, onchangeTrigger, placeholder) {

        if (ctrlSelector == null || ctrlSelector == "" || $(ctrlSelector).length == 0) {
            return;
        }

        this.controlSelector = ctrlSelector;
        this.dataURL = dataURL;
        this.filter = filter==null?null:filter.toString();
        this.defaultValue = defaultValue;
        this.onchangeTrigger = onchangeTrigger;
        this.enabled = enabled;
        this.onlyLeafSelection = onlyLeafSelection == null ? false :onlyLeafSelection;
        this.initControl(placeholder);
    }

    initControl(placeholder) {
        if (placeholder == null) {
            placeholder = "Selectati";
        }

        $(this.controlSelector).kendoDropDownTree({
            placeholder: placeholder,
            height: "auto",
            dataTextField: "Nume",
            dataValueField: "Id",
            filter: "contains",
            dataSource: this.getTreeDataSource(null, this.defaultValue),
            loadOnDemand: true,
            value: this.defaultValue,
            enable: this.enabled == null ? true : this.enabled,
            template: (e) => {
                return this.currentFilter != null && this.currentFilter.trim().length > 3 ? this.highlightText(e.item.Nume, this.currentFilter) : e.item.Nume;
            },
            filtering: (e) => {
                var tree = $(this.controlSelector).data("kendoDropDownTree");
                tree.setDataSource(this.getTreeDataSource(e.filter.value, null));
                e.preventDefault();
            },
            select: (e)=> {

                if (this.onlyLeafSelection && e.sender.dataItem(e.node).hasChildren) {
                    e.preventDefault()
                }
            },

            change:  (e) =>{
                var _val = $(this.controlSelector).data("kendoDropDownTree").value();
                _val = (_val != null && _val.toString().trim() == "") ? null : _val;
                if (this.onchangeTrigger != null) {
                    this.onchangeTrigger(_val);
                }
            }
        });
    }

    focus() {

        $(this.controlSelector).data("kendoDropDownTree").focus();
    }

    enable() {
        var ctrl = $(this.controlSelector).data("kendoDropDownTree");
        ctrl.enable(true);
    }

    disable() {
        var ctrl = $(this.controlSelector).data("kendoDropDownTree");
        ctrl.enable(false);
    }

    getValue() {
        var ctrl = $(this.controlSelector).data("kendoDropDownTree");
        return ctrl.value();
    }

    setValue(_val) {
        var ctrl = $(this.controlSelector).data("kendoDropDownTree");
        ctrl._clearFilter();
        ctrl.setDataSource(this.getTreeDataSource(null, _val));
        ctrl.value(_val);
        if (this.onchangeTrigger) {
            this.onchangeTrigger(_val);
        }
    }

    clear() {
        var ctrl = $(this.controlSelector).data("kendoDropDownTree");
        ctrl._clearFilter();
        ctrl.setDataSource(this.getTreeDataSource(null, null));
        ctrl.value(null);
    }

    updateFilter(filter) {

        this.filter = filter == null ? null : filter.toString();
        this.clear();
    }

    getTreeDataSource(searchText, selectedValue) {

        this.currentFilter = (searchText == null || searchText.trim().length < 3) ? null : searchText;
        this.initialFilteredDataSource = null;

        return new kendo.data.HierarchicalDataSource(
            {
                transport: {
                    read: (options) => {
                        if (options.data.Id == null) {
                            this.initialFilteredDataSource = this.getData(this.currentFilter, selectedValue, null);
                            options.success(this.initialFilteredDataSource);
                        }
                        else {
                            var currentItem = this.getItem(this.initialFilteredDataSource, options.data.Id);
                            if (currentItem != null && currentItem.HasChildren && currentItem.items.length > 0) {
                                options.success(currentItem.items);
                                return;
                            }
                            options.success(this.getData(null, null, options.data.Id));
                        }
                    }
                },
                schema: {
                    model: {
                        id: "Id",
                        hasChildren: "HasChildren"
                    }
                }
            });

    }

    getData(searchText, selectedValue, nodeId) {

        var result = [];
        this.nodeId = null;

        var url = this.dataURL;
        if (this.filter!=null && this.filter.toString().trim()!="") {
            url += "?filter=" + this.filter.toString().trim();
        }
        if (selectedValue) {
            url += "?selectedTreeNodeId=" + selectedValue.toString();
        }
        else if (searchText != null && searchText.length > 3) {
            url += "?searchText=" + searchText;
        }
        else if (nodeId != null) {
            url += "?treeNodeId=" + nodeId;
            this.nodeId = nodeId;
        }

        $.ajax({
            url: url,
            dataType: "json",
            async: false,
            success: (_result) => {
                if (_result == null || _result.length == 0) {
                    result = [];
                }
                else {
                    result = this.processTable(_result);
                }
            },
            error: (result) => {
                result = [];
                console.log(result);
            }
        });

        return result;
    }

    processTable(data) {
       
        var hash = {};
        for (var i = 0; i < data.length; i++) {
            var item = data[i];
            item.expanded = false;

            var id = item["Id"];
            var parentId = item["IdParinte"];

            hash[id] = hash[id] || [];
            hash[parentId] = hash[parentId] || [];

            item.items = hash[id];
            item.expanded = item.items != null && item.items.length > 0;
            hash[parentId].push(item);
        }

        var result = hash[this.nodeId == null ? 0 : this.nodeId];
       
        this.setExpand(result);
        return result;
    }

    setExpand(data) {
        if (data == null) {
            return;
        }
        if (!Array.isArray(data)) {
            data.expanded = data.items != null && data.items.length > 0;
            if (data.expanded) {
                this.setExpand(data.items);
            }
        }
        else {
            for (var i = 0; i < data.length; i++) {
                this.setExpand(data[i]);
            }
        }
    }

    getItem(data, id) {

        if (!Array.isArray(data)) {
            if (data.Id == id) {
                return data;
            }
            if (data.items != null) {
                for (var i = 0; i < data.items.length; i++) {
                    var _item = this.getItem(data.items[i], id);
                    if (_item != null) {
                        return _item;
                    }
                }
            }
        }
        else {
            for (var i = 0; i < data.length; i++) {
                var _item = this.getItem(data[i], id);
                if (_item != null) {
                    return _item;
                }
            }
        }

        return null;
    }

    highlightText(text, searchedText) {
        
        var result = text;
        var _text = this.removeDiacritics(text.toLowerCase());
        var _searchedText = this.removeDiacritics(searchedText.toLowerCase().trim());

        var occurences = _text.split(_searchedText).map(function (culm) {
            return this.pos += culm.length + _searchedText.length
        }, { pos: -_searchedText.length }).slice(0, -1);
        occurences = occurences.reverse();

        for (var i = 0; i < occurences.length; i++) {
            var str = text.substring(occurences[i], occurences[i]+ _searchedText.length);
            var classes = 'highlight_filter';
            if (occurences[i] > 0 && text[occurences[i] - 1] == " ") {
                classes += ' ml-1';
            }
            if ((occurences[i] + str.length) < text.length && text[occurences[i] + str.length] == " ") {
                classes += ' mr-1';
            }
            result = result.substr(0, occurences[i]) + ("<span class='" + classes + "'>" + str + "</span>")
                + result.substr(occurences[i] + str.length);
        }

        return result;
    }

    removeDiacritics(value) {
        var diacriticsMap = {
            'ã':'a',
            'à': 'a',
            'â': 'a',
            'ă': 'a',
            'é': 'e',
            'è': 'e',
            'ê': 'e',
            'ì': 'i',
            'î': 'i',
            'ò': 'o',
            'ô': 'o',
            'ş': 's',
            'ș': 's',
            'ţ': 't',
            'ț': 't',
            'ù': 'u',
            'û': 'u',
            'ÿ': 'y',
        };
        var diacriticsRegExp = new RegExp(Object.keys(diacriticsMap).join("|"), "ig");
        return value.replace(diacriticsRegExp, function (match) {
            return diacriticsMap[match] || match;
        });
    };

}